var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSahrawiArabDemocraticRepublic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_7269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.402 144.696C9.128 178.352 0 216.109 0 256C0 295.891 9.128 333.648 25.402 367.304L256 389.565L486.598 367.304C502.872 333.648 512 295.891 512 256C512 216.109 502.872 178.352 486.598 144.696L256 122.435L25.402 144.696Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.411 367.304C66.817 452.935 154.507 512 256 512C357.493 512 445.183 452.935 486.589 367.304H25.411Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.411 144.696H486.589C445.183 59.065 357.494 0 256 0C154.506 0 66.817 59.065 25.411 144.696Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.98 74.98C-24.994 174.954 -24.994 337.045 74.98 437.02C116.293 395.707 156.026 355.974 256 256L74.98 74.98Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.783 256C322.783 218.702 348.996 187.543 384 179.899C378.62 178.724 373.038 178.087 367.304 178.087C324.273 178.087 289.391 212.969 289.391 256C289.391 299.031 324.273 333.913 367.304 333.913C373.037 333.913 378.619 333.276 384 332.101C348.996 324.457 322.783 293.298 322.783 256Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.273 205.913L398.326 239.927H434.087L405.155 260.945L416.207 294.957L387.273 273.937L358.342 294.957L369.395 260.945L340.461 239.927H376.222L387.273 205.913Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_7269"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSahrawiArabDemocraticRepublic);
export default __webpack_public_path__ + "static/media/sahrawiArabDemocraticRepublic.5b37a2629503dc4353b615db3a382e87.svg";
export { ForwardRef as ReactComponent };